var _rect, _rect2, _rect3, _rect4, _rect5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarsScale(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2.8,
    height: 12,
    x: 1,
    y: 6,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "svgSpinnersBarsScale0",
    attributeName: "y",
    begin: "0;svgSpinnersBarsScale1.end-0.1s",
    calcMode: "spline",
    dur: "0.6s",
    keySplines: ".36,.61,.3,.98;.36,.61,.3,.98",
    values: "6;1;6"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    begin: "0;svgSpinnersBarsScale1.end-0.1s",
    calcMode: "spline",
    dur: "0.6s",
    keySplines: ".36,.61,.3,.98;.36,.61,.3,.98",
    values: "12;22;12"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2.8,
    height: 12,
    x: 5.8,
    y: 6,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    begin: "svgSpinnersBarsScale0.begin+0.1s",
    calcMode: "spline",
    dur: "0.6s",
    keySplines: ".36,.61,.3,.98;.36,.61,.3,.98",
    values: "6;1;6"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    begin: "svgSpinnersBarsScale0.begin+0.1s",
    calcMode: "spline",
    dur: "0.6s",
    keySplines: ".36,.61,.3,.98;.36,.61,.3,.98",
    values: "12;22;12"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2.8,
    height: 12,
    x: 10.6,
    y: 6,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    begin: "svgSpinnersBarsScale0.begin+0.2s",
    calcMode: "spline",
    dur: "0.6s",
    keySplines: ".36,.61,.3,.98;.36,.61,.3,.98",
    values: "6;1;6"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    begin: "svgSpinnersBarsScale0.begin+0.2s",
    calcMode: "spline",
    dur: "0.6s",
    keySplines: ".36,.61,.3,.98;.36,.61,.3,.98",
    values: "12;22;12"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2.8,
    height: 12,
    x: 15.4,
    y: 6,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    begin: "svgSpinnersBarsScale0.begin+0.3s",
    calcMode: "spline",
    dur: "0.6s",
    keySplines: ".36,.61,.3,.98;.36,.61,.3,.98",
    values: "6;1;6"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    begin: "svgSpinnersBarsScale0.begin+0.3s",
    calcMode: "spline",
    dur: "0.6s",
    keySplines: ".36,.61,.3,.98;.36,.61,.3,.98",
    values: "12;22;12"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 2.8,
    height: 12,
    x: 20.2,
    y: 6,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "svgSpinnersBarsScale1",
    attributeName: "y",
    begin: "svgSpinnersBarsScale0.begin+0.4s",
    calcMode: "spline",
    dur: "0.6s",
    keySplines: ".36,.61,.3,.98;.36,.61,.3,.98",
    values: "6;1;6"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    begin: "svgSpinnersBarsScale0.begin+0.4s",
    calcMode: "spline",
    dur: "0.6s",
    keySplines: ".36,.61,.3,.98;.36,.61,.3,.98",
    values: "12;22;12"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarsScale);
export default __webpack_public_path__ + "static/media/bars-scale.35ef52bc758c1d0aed0fd5d773208a1b.svg";
export { ForwardRef as ReactComponent };